import { render, staticRenderFns } from "./mobile-root.vue?vue&type=template&id=289a2bfc&scoped=true&"
import script from "./mobile-root.vue?vue&type=script&lang=ts&"
export * from "./mobile-root.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-root.vue?vue&type=style&index=0&id=289a2bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a2bfc",
  null
  
)

component.options.__file = "mobile-root.vue"
export default component.exports